var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaltReservoirValveOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 20,
    viewBox: "0 0 58 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M58,16.62H52.82a4.173,4.173,0,0,0-4.22-4.11H9.4a4.166,4.166,0,0,0-4.22,4.11H0A9.285,9.285,0,0,1,9.4,7.48H48.6A9.285,9.285,0,0,1,58,16.62Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M29.4,11.59l-11,7.23V1.18l11,7.23,11-7.23V18.82Z",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M39.76,2.37V17.63l-5.81-3.82-4.54-2.98-4.54,2.98-5.81,3.82V2.37l5.81,3.82,4.54,2.98,4.54-2.98,5.81-3.82M17.75,0V20l2.02-1.33,5.81-3.82,3.82-2.51,3.82,2.51,5.81,3.82L41.05,20V0L39.03,1.33,33.22,5.15,29.4,7.65,25.58,5.14,19.77,1.32,17.75,0Z",
    fill: "#6a7084"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaltReservoirValveOff);
export default __webpack_public_path__ + "static/media/salt_reservoir_valve_off.8283f69c7edcf947764a30bb58b9cbfb.svg";
export { ForwardRef as ReactComponent };